import React from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';

import { TListingAutomotiveTrustIndicators } from 'types/TListing';
import Warranty from './Warranty';

import Classes from './TrustIndicators.module.scss';
import QualityMark from './QualityMark';

type TTrustIndicatorsProps = {
  trustIndicators: TListingAutomotiveTrustIndicators;
};

const TrustIndicators = ({ trustIndicators }: TTrustIndicatorsProps) => {
  const { t } = useI18nContext();

  const { qualityMarks, warranties } = trustIndicators;

  return (
    <section className={Classes.root}>
      <div className={Classes.title}>{t('listing.trustIndicators.title')}</div>
      <div className={Classes.trustIndicators}>
        {!!warranties.length && warranties.map((warranty) => <Warranty key={warranty.id} warranty={warranty} />)}
        {!!qualityMarks.length &&
          qualityMarks.map((qualityMark) => <QualityMark key={qualityMark.type} qualityMark={qualityMark} />)}
      </div>
    </section>
  );
};

export default TrustIndicators;
